// extracted by mini-css-extract-plugin
export default {"wrapper":"StreamContainer_wrapper__cMqjX","iframe":"StreamContainer_iframe__LmpeD","nonCursor":"StreamContainer_nonCursor__r8uI2"};